'use client';

import { Link as ChakraLink } from '@chakra-ui/react';
import { createLink, type LinkComponent } from '@tanstack/react-router';

import type { JSX } from 'react';

import type { IBaseProps } from './interface';

function ChakraLinkComponent({ ref, ...props }: IBaseProps): JSX.Element {
  return <ChakraLink ref={ref} {...props} />;
}

const TanstackLink = createLink(ChakraLinkComponent);

export const Link: LinkComponent<typeof ChakraLinkComponent> = (props) => {
  return <TanstackLink preload='intent' {...props} />;
};
